import { State } from '../../../../store/types';
import { SLICE_NAME } from './types';

export const selectDateFilter = () => (state: State) => {
  return {
    start_date: state[SLICE_NAME].start_date,
    end_date: state[SLICE_NAME].end_date,
  };
};
